
import searchResult from './data/searchResult'
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms))
let shouldReject = false

export default {
  search (searchPayload) {
    console.log('** search mock **', searchPayload)
    return new Promise((resolve, reject) => {
      delay(700).then(() => {
        if (shouldReject) {
          console.error('rejected', reject)
        } else {
          return resolve(searchResult)
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/mock/searchMockApi.js